export default import.meta.ROLLDOWN_FILE_URL_bSOXiKUlWuX2_kcenm7s$Q